var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{center_loading: _vm.center}},[_c('img',{attrs:{"src":require("../../assets/img/loading.svg"),"width":"120","height":"120"}})])}
var staticRenderFns = []

export { render, staticRenderFns }